import { mockCoupons } from "../../constants/mockdata";
const Dashboard = () => {
    const stats = [
        { label: "Total Revenue", value: "£42,567", change: "+12.5%", changeType: "increase" },
        { label: "Total Orders", value: "1,890", change: "+8.2%", changeType: "increase" },
        { label: "New Customers", value: "215", change: "-2.1%", changeType: "decrease" },
        { label: "Active Coupons", value: mockCoupons.filter(c => c.status === 'Active').length, change: "+3", changeType: "increase" },
    ];
    return (
        <div className="space-y-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {stats.map((stat, idx) => (
                    <div key={idx} className="bg-white shadow-lg rounded-xl p-6 transition hover:shadow-xl hover:-translate-y-1">
                        <p className="text-sm font-medium text-gray-500">{stat.label}</p>
                        <p className="text-3xl font-bold text-gray-800 mt-2">{stat.value}</p>
                        <div className="flex items-center mt-2">
                            <span className={`text-xs font-semibold px-2 py-1 rounded-full ${stat.changeType === 'increase' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>{stat.change}</span>
                            <span className="text-xs text-gray-500 ml-2">vs last month</span>
                        </div>
                    </div>
                ))}
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                <div className="lg:col-span-3 bg-white shadow-lg rounded-xl p-6">
                    <h3 className="font-semibold text-gray-800">Sales Analytics (Last 6 Months)</h3>
                    <div className="mt-4 h-64 bg-gray-100 rounded-lg flex items-center justify-center"><p className="text-gray-500">Chart will be rendered here.</p></div>
                </div>
                <div className="lg:col-span-2 bg-white shadow-lg rounded-xl p-6">
                    <h3 className="font-semibold text-gray-800">Recent Activity</h3>
                    <ul className="mt-4 space-y-3">
                        <li className="flex items-center text-sm"><div className="w-8 h-8 rounded-full bg-green-100 text-green-600 flex items-center justify-center mr-3">✓</div><p className="text-gray-600">New order <span className="font-bold">#ORD-2025-001</span> received.</p><span className="text-gray-400 ml-auto">2m ago</span></li>
                        <li className="flex items-center text-sm"><div className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mr-3">👤</div><p className="text-gray-600">New user <span className="font-bold">Emma W.</span> registered.</p><span className="text-gray-400 ml-auto">1h ago</span></li>
                        <li className="flex items-center text-sm"><div className="w-8 h-8 rounded-full bg-red-100 text-red-600 flex items-center justify-center mr-3">✗</div><p className="text-gray-600">Order <span className="font-bold">#ORD-2025-004</span> was cancelled.</p><span className="text-gray-400 ml-auto">5h ago</span></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;